/**
 * Sales points Js functionality.
 */
export default function salesPoints() {
  const salesPointsOrganism = document.querySelector( '[data-type="organism/sales-points/sales-points"]' )
  const salesPointTypeFilter = document.querySelectorAll( '.sales-point-type-filter' )

  if ( salesPointTypeFilter.length === 0 || salesPointsOrganism.length === 0 ) {
    return
  }

  const salesPointAccordions = salesPointsOrganism.querySelectorAll( '.js-accordion' )

  salesPointTypeFilter.forEach( filterOption => {
    filterOption.addEventListener( 'click', e => {
      e.preventDefault()

      // Remove the checked styles for the radio buttons.
      removeActiveClassname( salesPointTypeFilter )

      // Remove the visible accordions.
      hideAccordions( salesPointAccordions )

      // Add the checked styles for the selected filter.
      e.target.classList.add( 'active' )

      // Show the selected accordion.
      document.querySelector( `.${e.target.dataset.spType}` ).style.display = 'block'

      // Update the window data.
      updateWindowData( e.target.dataset.spUrl )
    })
  })
}

/**
 * Remove the active class for all provided items.
 *
 * @param {array} items element items.
 */
function removeActiveClassname( items ) {
  items.forEach( item => item.classList.remove( 'active' ) )
}

/**
 * Hide accordion elements for all provided items.
 *
 * @param {array} items accordion items.
 */
function hideAccordions( items ) {
  items.forEach( item => item.style.display = 'none' )
}

/**
 * Update the window data.
 *
 * @param {string} pushUrl Url to be pushed.
 */
function updateWindowData( pushUrl ) {
  // Update window.
  window.history.pushState({}, document.title, pushUrl )
}
